import React from 'react';
import tsWhiteLogo from '../../assets/images/TS_Logo.png'
const Logo = () => (
    <a href="https://www.tradestation.com" target="_blank" rel="noopener noreferrer">
        <img src={ tsWhiteLogo } className="img-fluid ts-logo" alt="TradeStation" />
    </a>
);

export default Logo;